import { FaxState } from "../interfaces/fax"
import { Types } from "../types"
import { FaxActions } from "../types/fax/actionTypes"

const initialState: FaxState = {
    customerFaxNumbers: [],
    getResendFaxPending: false,
    getCustomerHasIvrProductPending: false,
    customerHasIvrProduct: false,
    sendFaxSuccess: null,
    sendFaxPending: false,
    deleteInboxItemSuccess: false,
    deleteInboxItemPending: false,
    downloadFaxOutboxFilePending: false,
    downloadFaxOutboxFileResult: undefined,
    downloadFaxOutboxFileSuccess: false,
    downloadFaxInboxFileSuccess: false,
    downloadFaxInboxFileResult: undefined,
    downloadFaxInboxFilePending: false,
    getResendFaxSuccess: null,
    sendFaxError: null,
    customerActiveFaxNumbers: []
}


const faxReducer = (state = initialState, action: FaxActions, response: any) => {

    switch (action.type) {
        case Types.GET_FAX_INBOX_REQUEST:
            return {
                ...state,
                getFaxInboxPending: true,
                getFaxInboxError: null,

            }
        case Types.GET_FAX_INBOX_SUCCESS:

            return {
                ...state,
                getFaxInboxPending: false,
                getFaxInboxError: null,
                faxInbox: action.response

            }

        case Types.GET_FAX_INBOX_ERROR:

            return {
                ...state,
                getFaxInboxPending: false,
                getFaxInboxError: action.payload
            }

        case Types.GET_FAX_OUTBOX_REQUEST:
            return {
                ...state,
                getFaxOutboxPending: true,
                getFaxOutboxError: null,
            }
        case Types.GET_FAX_OUTBOX_SUCCESS:

            return {
                ...state,
                getFaxOutboxPending: false,
                getFaxOutboxError: null,
                faxOutbox: action.response
            }

        case Types.GET_FAX_OUTBOX_ERROR:

            return {
                ...state,
                getFaxOutboxPending: false,
                getFaxOutboxError: action.payload
            }


        case Types.SEND_NEW_FAX_REQUEST:
            return {
                ...state,
                sendFaxPending: true,
                sendFaxSuccess: false,

                sendFaxError: null,
            }
        case Types.SEND_NEW_FAX_SUCCESS:

            return {
                ...state,
                sendFaxPending: false,
                sendFaxSuccess: action.response,

            }

        case Types.SEND_NEW_FAX_ERROR:

            return {
                ...state,
                sendFaxPending: false,
                sendFaxError: action.payload
            }


        case Types.GET_CUSTOMER_FAX_NUMBERS_REQUEST:
            return {
                ...state,
                getCustomerFaxNumbersPending: true,
                getCustomerFaxNumbersError: null,
                customerFaxNumbers: []
            }
        case Types.GET_CUSTOMER_FAX_NUMBERS_SUCCESS:

            return {
                ...state,
                getCustomerFaxNumbersPending: false,
                getCustomerFaxNumbersError: null,
                customerFaxNumbers: action.response
            }

        case Types.GET_CUSTOMER_FAX_NUMBERS_ERROR:

            return {
                ...state,
                getCustomerFaxNumbersPending: false,
                getCustomerFaxNumbersError: action.payload
            }



        case Types.GET_HAS_CUSTOMER_IVR_PRODUCT_REQUEST:
            return {
                ...state,
                getCustomerHasIvrProductPending: true,
                getCustomerHasIvrProductError: null,
            }
        case Types.GET_HAS_CUSTOMER_IVR_PRODUCT_SUCCESS:

            return {
                ...state,
                getCustomerHasIvrProductPending: false,
                getCustomerHasIvrProductError: null,
                customerHasIvrProduct: action.response
            }

        case Types.GET_HAS_CUSTOMER_IVR_PRODUCT_ERROR:

            return {
                ...state,
                getCustomerHasIvrProductPending: false,
                getCustomerHasIvrProductError: action.payload
            }


        case Types.GET_DOWNLOAD_OUTBOX_FILE_REQUEST:
            return {
                ...state,
                downloadFaxOutboxFilePending: true,
                downloadFaxOutboxFileError: null,
                downloadFaxOutboxFileSuccess: false,
                downloadFaxOutboxFileResult: null

            }
        case Types.GET_DOWNLOAD_OUTBOX_FILE_SUCCESS:

            return {
                ...state,
                downloadFaxOutboxFilePending: false,
                downloadFaxOutboxFileSuccess: true,
                downloadFaxOutboxFileResult: action.response
            }

        case Types.GET_DOWNLOAD_OUTBOX_FILE_ERROR:

            return {
                ...state,
                downloadFaxOutboxFilePending: false,
                downloadFaxOutboxFileError: action.payload
            }


        case Types.GET_DOWNLOAD_INBOX_FILE_REQUEST:
            return {
                ...state,
                downloadFaxInboxFilePending: true,
                downloadFaxInboxFileError: null,
                downloadFaxInboxFileResult: null,
                downloadFaxInboxFileSuccess: false,

            }
        case Types.GET_DOWNLOAD_INBOX_FILE_SUCCESS:

            return {
                ...state,
                downloadFaxInboxFilePending: false,
                downloadFaxInboxFileSuccess: true,

                downloadFaxInboxFileResult: action.response

            }

        case Types.GET_DOWNLOAD_INBOX_FILE_ERROR:

            return {
                ...state,
                downloadFaxInboxFilePending: false,
                downloadFaxInboxFileError: action.payload
            }


        case Types.GET_DELETE_INBOX_ITEM_REQUEST:
            return {
                ...state,
                deleteInboxItemPending: true,
                deleteInboxItemError: null,
                deleteInboxItemSuccess: false
            }
        case Types.GET_DELETE_INBOX_ITEM_SUCCESS:

            return {
                ...state,
                deleteInboxItemPending: false,
                deleteInboxItemSuccess: true
            }

        case Types.GET_DELETE_INBOX_ITEM_ERROR:

            return {
                ...state,
                deleteInboxItemPending: false,
                deleteInboxItemError: action.payload
            }



        case Types.GET_RESEND_FAX_REQUEST:
            return {
                ...state,
                getResendFaxPending: true,
                getResendFaxError: null,
                getResendFaxSuccess: null
            }
        case Types.GET_RESEND_FAX_SUCCESS:

            return {
                ...state,
                getResendFaxPending: false,
                getResendFaxSuccess: action.response
            }

        case Types.GET_RESEND_FAX_ERROR:

            return {
                ...state,
                getResendFaxPending: false,
                getResendFaxError: action.payload
            }

        case Types.GET_CUSTOMER_ACTIVE_FAX_NUMBER_REQUEST:
            return {
                ...state,
                getCustomerActiveFaxNumberPending: true,
                getCustomerActiveFaxNumberError: null,
                getCustomerActiveFaxNumberSuccess: null
            }
        case Types.GET_CUSTOMER_ACTIVE_FAX_NUMBER_SUCCESS:

            return {
                ...state,
                getCustomerActiveFaxNumberPending: false,
                customerActiveFaxNumbers: action.response
            }

        case Types.GET_CUSTOMER_ACTIVE_FAX_NUMBER_ERROR:

            return {
                ...state,
                getCustomerActiveFaxNumberPending: false,
                getCustomerActiveFaxNumberError: action.payload
            }



        case Types.RESET_FAX_PROPS:

            return {
                ...state,
                selectPackagePending: false,
                selectPackageSuccess: false,
                selectPackageError: null,
                deleteInboxItemPending: false,
                deleteInboxItemError: null,
                deleteInboxItemSuccess: false,
                downloadFaxInboxFileError: null,
                downloadFaxInboxFilePending: false,
                downloadFaxInboxFileResult: null,
                downloadFaxInboxFileSuccess: false,
                downloadFaxOutboxFilePending: false,
                downloadFaxOutboxFileError: null,
                downloadFaxOutboxFileSuccess: false,
                downloadFaxOutboxFileResult: null,
                sendFaxPending: false,
                sendFaxSuccess: null,
                sendFaxError: null,
                getResendFaxPending: false,
                getResendFaxError: null,
                getResendFaxSuccess: null
            }





        default:
            return {
                ...state
            }
    }
}

export default faxReducer